import * as Api from '@/utils/request'

import * as Api2 from '@/utils/appRequest'


import * as Mobile from "../../utils/mobileRequest";
import * as Api_jf from '../../utils/requestUri';


export default {

  async getZxLogin() {
    return await Api.get({
      url: '/H5ReactZxLogin/zhongXunLogin',
    })
  },
  /**
   * 获取个人主页数据
   * @returns {Promise.<*>}
   */

  //获取个人主页用户个人资料
  async getUserInfo(userOpt) {
    return await Api.get({
      url: '/H5ReactUserCenter/getUserInfo',
      // params:{user_id:15493}
      params: userOpt

    })
    //   return  {
    //     "id": 15493,
    //     "l_id": 0,
    //     "username": "P15311415002",
    //     "avatar": "http://img1-cdn-picsh.aigupiao.com/user/avatar/2019-01-24/f90557de923783d09161e1a845417ca9.jpg",
    //     "brief": "看看",
    //     "province": "北京",
    //     "city": "顺义区",
    //     "start_year": 4,
    //     "stock_fund": "500万以上",
    //     "gender": "男",
    //     "is_talent": "no",
    //     "serve_vip": "no",
    //     "is_elite": "no",
    //     "is_official": "no",
    //     "realname": "枫5",
    //     "area": "北京顺义区",
    //     "releases_number": 284,
    //     "concerns_number": 21,
    //     "fans_number": 2725,
    //     "praised_number": "51",
    //     "tag_list": [
    //         {
    //             "label": "短线"
    //         },
    //         {
    //             "label": "题材挖掘"
    //         },
    //         {
    //             "label": "长线"
    //         }
    //     ]
    // }
  },
  async getUserInfoStatus() {
    //Api_jf Api
    return await Api_jf.get({
      url: '/H5ReactUserCenter/index',
    })
  },
  //获取个人主页用户tag标签获取（如主页  专栏   问答  相册  等）
  async getTagsList(userOpt) {
    return await Api.get({
      url: '/H5ReactLives/getTags',
      params: userOpt
    })
  },
  //获取老师个人主页全部直播列表
  async getCenterList(userid, before) {
    return await Api.get({
      url: '/H5ReactLives/center',
      params: { id: userid, before }
    })
  },

  //获取用户个人主页全部直播列表
  async getUserCenterList(userid, before) {
    return await Api.get({
      url: '/H5ReactLives/consumerCenter',
      params: { m_u_id: userid, before }
    })
  },

  //获取老师个人主页 专栏列表
  async getColumnsList(userid, before) {
    return await Api.get({
      url: '/H5ReactLives/getColumns',
      params: { l_id: userid, before }
    })
  },

  //获取用户个人主页 专栏列表
  async getUserColumnsList(userid, before) {
    return await Api.get({
      url: '/H5ReactLives/consumerColumns',
      params: { m_u_id: userid, before }
    })
  },

  //获取老师个人主页  精华列表
  async getEssenceList(userid, before) {
    return await Api.get({
      url: '/H5ReactLives/getEssence',
      params: { l_id: userid, before }
    })
  },

  //获取老师个人主页  问答—》全部问答列表
  async getQaList(userid, before) {
    return await Api.get({
      url: '/H5ReactLives/qaList',
      params: { l_id: userid, before }
    })
  },

  //获取老师个人主页  问答—》我的提问
  async getMyqList(userid) {
    return await Api.get({
      url: '/H5ReactLives/myqList',
      params: { l_id: userid }
    })
  },

  //获取老师个人主页  视频列表
  async getVideoList(userid, before) {
    return await Api.get({
      url: '/H5ReactLives/videoList',
      params: { l_id: userid, before }
    })
  },

  //获取用户个人主页  组合列表
  async getConsumerCombination(userid) {
    return await Api.get({
      url: '/H5ReactLives/consumerCombination',
      params: { m_u_id: userid }
    })
  },

  //获取用户个人主页  相册列表
  async getConsumerPhotoList(userid, before, sort_id) {
    return await Api.get({
      url: '/H5ReactLives/consumerPhotoList',
      params: { m_u_id: userid, before, sort_id }
    })
  },






  //获取投顾老师个人主页全部直播列表
  async getAdvisorCenterList(userid, before,login_user_id) {
    return await Api2.get2({
      url: '/v1/liveMsg/get_list',
      params: { view_live_id: userid, before_time: before, kind: 'all', login_user_id:login_user_id ,source:'wap'}
    })
  },

  async getAdvisorVipList(userid, before,login_user_id) {
    return await Api2.get2({
      url: '/v1/liveMsg/get_list',
      params: { view_live_id: userid, before_time: before, kind: 'vip', login_user_id:login_user_id ,source:'wap'}
    })
  },

  //获取投顾老师个人主页专栏列表
  async getAdvisorColumnsList(userid, before,login_user_id) {
    return await Api2.get2({
      url: '/v1/liveMsg/get_list',
      params: { view_live_id: userid, before_time: before, kind: 'charge',source:'wap', login_user_id: login_user_id }
    })
  },
  //获取投顾老师个人主页精华列表
  async getAdvisorEssenceList(userid, before,login_user_id) {
    return await Api2.get2({
      url: '/v1/liveMsg/get_list',
      params: { view_live_id: userid, before_time: before, kind: 'essence',source:'wap', login_user_id: login_user_id }
    })
  },
}